import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CadastroService } from 'src/app/services/cadastro.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-dados-associado',
    templateUrl: './dados-associado.component.html',
    styleUrls: ['./dados-associado.component.css'],
    imports: []
})
export class DadosAssociadoComponent implements OnInit {

  @Output() exibirItem = new EventEmitter();

  dados: any = null;

  constructor(private cadastro: CadastroService) { }

  ngOnInit() {
    this.carregarDados();
  }

  carregarDados(){

    this.cadastro
    .dadosAssociado()
    .subscribe(
      (res: any) => {

        if(res!=null){
          this.exibirItem.emit(true);
          this.dados = res;
        }

      },
    )

  }

}
